import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { StyledEngineProvider } from "@mui/material";

import PublicSite from "./public/PublicSite";
import HomePage from "./public/pages/HomePage";
import CatalogPage from "./public/pages/CatalogPage";
import ListingPage from "./public/pages/ListingPage";
import QuizPage from "./public/pages/QuizPage";
import ContactsPage from "./public/pages/ContactsPage";
import NotFoundPage from "./public/pages/NotFoundPage";
import AdminApp from "./AdminApp";

/**
 * Cognito's Hosted UI is configured to return to https://leocity.estate/ , which
 * is now the public home page. When a token lands there, hand it straight over
 * to the admin app (the hash carries `#id_token=...`, so it survives the
 * redirect untouched).
 */
function CognitoTokenGate({ children }) {
  const location = useLocation();
  const hasToken =
    window.location.href.indexOf("id_token") !== -1 ||
    location.hash.indexOf("id_token") !== -1;

  if (hasToken) {
    return <Navigate to={"/admin" + location.hash} replace />;
  }
  return children;
}

function App() {
  return (
    <StyledEngineProvider injectFirst>
      <BrowserRouter>
        <Routes>
          {/* ------------------------------------------------ public website */}
          <Route element={<PublicSite />}>
            <Route
              index
              element={
                <CognitoTokenGate>
                  <HomePage />
                </CognitoTokenGate>
              }
            />
            <Route path="katalog" element={<CatalogPage />} />
            <Route path="kvartyra/:object_id" element={<ListingPage />} />
            <Route path="krosvord" element={<QuizPage />} />
            <Route path="kontakty" element={<ContactsPage />} />

            {/* Links shared before the redesign used /View/<id> — keep them alive. */}
            <Route path="View/:object_id" element={<ListingPage />} />
            <Route path="View" element={<Navigate to="/katalog" replace />} />

            <Route path="*" element={<NotFoundPage />} />
          </Route>

          {/* -------------------------------------------- realtor admin panel */}
          <Route path="/admin" element={<AdminApp />} />
          <Route path="/admin/*" element={<AdminApp />} />

          {/* Old admin URLs. */}
          <Route path="/Clients" element={<Navigate to="/admin" replace />} />
          <Route path="/Archives" element={<Navigate to="/admin" replace />} />
        </Routes>
      </BrowserRouter>
    </StyledEngineProvider>
  );
}

export default App;
